export default "__VITE_ASSET__BGzc8cOp__"